<template>
  <div
    :class="{
      'is-not-app': !isApp,
      'common-fixed-points': true,
      show: show
    }"
  >
    <slot :scrollTop="scrollTop" :show="show" />
  </div>
</template>

<script>
import { getScrollTop } from 'lib/tools/utils.js'
export default {
  props: {
    stopTime: {
      type: Number,
      default: 200
    }
  },
  data() {
    return {
      scrollTop: 0,
      show: false
    }
  },
  computed: {
    isApp() {
      return this.$platform.isYixinliApp || this.$platform.isZiXunApp
    }
  },
  mounted() {
    // this.$nextTick(() => {
    //   this.show = true
    // })
    this.setScrollTimer = setTimeout(() => {
      this.scroll()
      window.addEventListener('scroll', this.scroll)
    }, 1000)
  },
  destroyed() {
    window.removeEventListener('scroll', this.scroll)
    clearTimeout(this.scrollTimer)
    clearTimeout(this.setScrollTimer)
  },
  methods: {
    scroll() {
      this.show = false
      this.scrollTop = getScrollTop() | 0
      clearTimeout(this.scrollTimer)
      this.scrollTimer = setTimeout(() => {
        this.show = true
      }, 200)
    }
  }
}
</script>

<style lang="scss">
.common-fixed-points {
  position: fixed;
  right: 26px;
  bottom: 100px;
  transform: translate3d(150%, 0, 0);
  transition: transform 0.5s;
  margin-bottom: env(safe-area-inset-bottom);
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  &.show {
    transform: translate3d(0, 0, 0);
  }
  &.is-not-app {
    bottom: 120px;
  }
}
</style>
